// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__23dQK","title":"AfterBackImages_title__1otWZ","images":"AfterBackImages_images__3V3ak"};